import React from 'react';

import { buttons } from '@pray/shared/components/foundations';
import Button from '@pray/shared/components/ui/Button';

const presets = {
  month: [
    { label: '$5', value: '500' },
    { label: '$10', value: '1000' },
    { label: '$15', value: '1500' },
    { label: '$20', value: '2000' },
    { label: '$25', value: '2500' },
    { label: 'Other', value: null },
  ],
  year: [
    { label: '$50', value: '5000' },
    { label: '$55', value: '5500' },
    { label: '$60', value: '6000' },
    { label: '$65', value: '6500' },
    { label: '$70', value: '7000' },
    { label: 'Other', value: null },
  ],
};

type DonationAmountPresetsProps = {
  interval: 'month' | 'year';
  onSelectAmount: (amount: string | null) => void;
};

export default function DonationAmountPresets({ interval, onSelectAmount }: DonationAmountPresetsProps) {
  return (
    <div className="my-8 grid grid-cols-3 gap-4">
      {presets[interval].map((preset) => (
        <Button
          key={preset.value}
          variant={buttons.variant.primary}
          className="!border-none !bg-[#00cc99]"
          onClick={() => onSelectAmount(preset.value)}
        >
          {preset.label}
        </Button>
      ))}
    </div>
  );
}
